var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "log-in-01",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "log-in-01-2",
    "data-name": "log-in-01",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.667,2.667,8,6,4.667,9.333",
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon-2",
    "data-name": "Icon",
    d: "M8,0h.8a4.969,4.969,0,0,1,2.108.218,2,2,0,0,1,.874.874A4.969,4.969,0,0,1,12,3.2V8.8a4.969,4.969,0,0,1-.218,2.108,2,2,0,0,1-.874.874A4.969,4.969,0,0,1,8.8,12H8M0,6H8",
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutarrow);
export default __webpack_public_path__ + "static/media/logoutarrow.3f06bf0d2e13744bef802d6b772a20e0.svg";
export { ForwardRef as ReactComponent };